import styled from '@emotion/styled';
import {
  Colors,
  helperButtonReset,
  helperLinkReset,
  helperListItemHover,
  helperTypographyText,
} from '@utex/ui-kit';

interface SubItemProps {
  isDisabled?: boolean;
}

export const NavItemSecond = styled('a')<SubItemProps>`
  ${helperLinkReset};
  ${helperButtonReset};
  ${helperTypographyText({
    size: 'M',
    lh: 'M',
  })};
  display: block;
  padding: 0.6rem 2rem;
  width: 100%;
  text-align: left;
  color: ${(props) => props.isDisabled && Colors.text.disabled};
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};

  ${helperListItemHover({
    activeBgColor: Colors.ut.listItemDown,
  })};
`;
